<template>
  <div class="topbar">
    <KeywordFilter :lookup="lookup()" :limit="productsLimit"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{products.total}}</template>
      </counters>
      <div class="buttonset">
        <router-link class="btn btn--secondary" :to="{ name: 'report-conference-products' }">{{ $t('conferencereport.generate_report') }}</router-link>&nbsp;
        <!--<router-link class="btn btn&#45;&#45;secondary" :to="{ name: 'export-products' }">{{ $t('top_bar.generate_report') }}</router-link>&nbsp;-->
        <!--<router-link class="btn btn--main" :to="{ name: 'add-product' }" v-if="isLandlord()">{{ $t('top_bar.add_new_product') }}</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KeywordFilter from 'common/KeywordFilter';
import Counters from 'common/Counters';
import Messages from 'common/Messages';

export default {
  components: {
    KeywordFilter,
    Counters,
    Messages,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    products: 'landlord/products/products',
    productsLimit: 'landlord/products/limit',
  }),
  methods: {
    lookup() {
      return this.isLandlord() ? 'products/fetch' : 'products/fetchTenantProducts';
    },
  },
};
</script>

<style lang="scss" scoped>
.messages {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/products/Topbar.vue